import React from "react"
import { OverlayTrigger, Tooltip } from "react-bootstrap"

import "./skillShowcase.css"

function SkillShowcase() {
  return (
    <div className="d-flex flex-row flex-wrap">
      <OverlayTrigger placement="top" overlay={<Tooltip>Node.js</Tooltip>}>
        <div className="skill-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            aria-hidden="true"
            focusable="false"
            width="0.89em"
            height="1em"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 256 289"
          >
            <path
              d="M128 288.464c-3.975 0-7.685-1.06-11.13-2.915l-35.247-20.936c-5.3-2.915-2.65-3.975-1.06-4.505c7.155-2.385 8.48-2.915 15.9-7.156c.796-.53 1.856-.265 2.65.265l27.032 16.166c1.06.53 2.385.53 3.18 0l105.74-61.217c1.06-.53 1.59-1.59 1.59-2.915V83.08c0-1.325-.53-2.385-1.59-2.915l-105.74-60.953c-1.06-.53-2.385-.53-3.18 0L20.405 80.166c-1.06.53-1.59 1.855-1.59 2.915v122.17c0 1.06.53 2.385 1.59 2.915l28.887 16.695c15.636 7.95 25.44-1.325 25.44-10.6V93.68c0-1.59 1.326-3.18 3.181-3.18h13.516c1.59 0 3.18 1.325 3.18 3.18v120.58c0 20.936-11.396 33.126-31.272 33.126c-6.095 0-10.865 0-24.38-6.625l-27.827-15.9C4.24 220.885 0 213.465 0 205.515V83.346C0 75.396 4.24 67.976 11.13 64L116.87 2.783c6.625-3.71 15.635-3.71 22.26 0L244.87 64C251.76 67.975 256 75.395 256 83.346v122.17c0 7.95-4.24 15.37-11.13 19.345L139.13 286.08c-3.445 1.59-7.42 2.385-11.13 2.385zm32.596-84.009c-46.377 0-55.917-21.2-55.917-39.221c0-1.59 1.325-3.18 3.18-3.18h13.78c1.59 0 2.916 1.06 2.916 2.65c2.12 14.045 8.215 20.936 36.306 20.936c22.261 0 31.802-5.035 31.802-16.96c0-6.891-2.65-11.926-37.367-15.372c-28.886-2.915-46.907-9.275-46.907-32.33c0-21.467 18.02-34.187 48.232-34.187c33.921 0 50.617 11.66 52.737 37.101c0 .795-.265 1.59-.795 2.385c-.53.53-1.325 1.06-2.12 1.06h-13.78c-1.326 0-2.65-1.06-2.916-2.385c-3.18-14.575-11.395-19.345-33.126-19.345c-24.38 0-27.296 8.48-27.296 14.84c0 7.686 3.445 10.07 36.306 14.31c32.597 4.24 47.967 10.336 47.967 33.127c-.265 23.321-19.345 36.571-53.002 36.571z"
              fill="#539E43"
            />
          </svg>
        </div>
      </OverlayTrigger>
      <OverlayTrigger placement="top" overlay={<Tooltip>React.js</Tooltip>}>
        <div className="skill-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            aria-hidden="true"
            focusable="false"
            width="1em"
            height="1em"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 32 32"
          >
            <circle cx="16" cy="15.974" r="2.5" fill="#00d8ff" />
            <path
              d="M16 21.706a28.385 28.385 0 0 1-8.88-1.2a11.3 11.3 0 0 1-3.657-1.958A3.543 3.543 0 0 1 2 15.974c0-1.653 1.816-3.273 4.858-4.333A28.755 28.755 0 0 1 16 10.293a28.674 28.674 0 0 1 9.022 1.324a11.376 11.376 0 0 1 3.538 1.866A3.391 3.391 0 0 1 30 15.974c0 1.718-2.03 3.459-5.3 4.541a28.8 28.8 0 0 1-8.7 1.191zm0-10.217a27.948 27.948 0 0 0-8.749 1.282c-2.8.977-4.055 2.313-4.055 3.2c0 .928 1.349 2.387 4.311 3.4A27.21 27.21 0 0 0 16 20.51a27.6 27.6 0 0 0 8.325-1.13C27.4 18.361 28.8 16.9 28.8 15.974a2.327 2.327 0 0 0-1.01-1.573a10.194 10.194 0 0 0-3.161-1.654A27.462 27.462 0 0 0 16 11.489z"
              fill="#00d8ff"
            />
            <path
              d="M10.32 28.443a2.639 2.639 0 0 1-1.336-.328c-1.432-.826-1.928-3.208-1.327-6.373a28.755 28.755 0 0 1 3.4-8.593a28.676 28.676 0 0 1 5.653-7.154a11.376 11.376 0 0 1 3.384-2.133a3.391 3.391 0 0 1 2.878 0c1.489.858 1.982 3.486 1.287 6.859a28.806 28.806 0 0 1-3.316 8.133a28.385 28.385 0 0 1-5.476 7.093a11.3 11.3 0 0 1-3.523 2.189a4.926 4.926 0 0 1-1.624.307zm1.773-14.7a27.948 27.948 0 0 0-3.26 8.219c-.553 2.915-.022 4.668.75 5.114c.8.463 2.742.024 5.1-2.036a27.209 27.209 0 0 0 5.227-6.79a27.6 27.6 0 0 0 3.181-7.776c.654-3.175.089-5.119-.713-5.581a2.327 2.327 0 0 0-1.868.089A10.194 10.194 0 0 0 17.5 6.9a27.464 27.464 0 0 0-5.4 6.849z"
              fill="#00d8ff"
            />
            <path
              d="M21.677 28.456c-1.355 0-3.076-.82-4.868-2.361a28.756 28.756 0 0 1-5.747-7.237a28.676 28.676 0 0 1-3.374-8.471a11.376 11.376 0 0 1-.158-4A3.391 3.391 0 0 1 8.964 3.9c1.487-.861 4.01.024 6.585 2.31a28.8 28.8 0 0 1 5.39 6.934a28.384 28.384 0 0 1 3.41 8.287a11.3 11.3 0 0 1 .137 4.146a3.543 3.543 0 0 1-1.494 2.555a2.59 2.59 0 0 1-1.315.324zm-9.58-10.2a27.949 27.949 0 0 0 5.492 6.929c2.249 1.935 4.033 2.351 4.8 1.9c.8-.465 1.39-2.363.782-5.434A27.212 27.212 0 0 0 19.9 13.74a27.6 27.6 0 0 0-5.145-6.64c-2.424-2.152-4.39-2.633-5.191-2.169a2.327 2.327 0 0 0-.855 1.662a10.194 10.194 0 0 0 .153 3.565a27.465 27.465 0 0 0 3.236 8.1z"
              fill="#00d8ff"
            />
          </svg>
        </div>
      </OverlayTrigger>
      <OverlayTrigger placement="top" overlay={<Tooltip>Next.js</Tooltip>}>
        <div className="skill-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            aira-hidden="true"
            focusable="false"
            width="1.66em"
            height="1em"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 512 309"
          >
            <path
              d="M120.81 80.561h96.568v7.676h-87.716v57.767h82.486v7.675h-82.486v63.423h88.722v7.675H120.81V80.561zm105.22 0h10.26l45.467 63.423L328.23 80.56L391.441 0l-103.85 150.65l53.515 74.127h-10.663l-48.686-67.462l-48.888 67.462h-10.461l53.917-74.128l-50.296-70.088zm118.898 7.676V80.56h110.048v7.676h-50.699v136.54h-8.852V88.237h-50.497zM0 80.56h11.065l152.58 228.323l-63.053-84.107L9.254 91.468l-.402 133.31H0V80.56zm454.084 134.224c-1.809 0-3.165-1.4-3.165-3.212c0-1.81 1.356-3.212 3.165-3.212c1.83 0 3.165 1.401 3.165 3.212c0 1.811-1.335 3.212-3.165 3.212zm8.698-8.45h4.737c.064 2.565 1.937 4.29 4.693 4.29c3.079 0 4.823-1.854 4.823-5.325v-21.99h4.823v22.011c0 6.252-3.617 9.853-9.603 9.853c-5.62 0-9.473-3.493-9.473-8.84zm25.384-.28h4.78c.409 2.953 3.294 4.828 7.45 4.828c3.875 0 6.717-2.005 6.717-4.764c0-2.371-1.809-3.794-5.921-4.764l-4.005-.97c-5.62-1.316-8.181-4.032-8.181-8.602c0-5.54 4.521-9.227 11.303-9.227c6.308 0 10.916 3.686 11.196 8.925h-4.694c-.452-2.867-2.95-4.657-6.567-4.657c-3.81 0-6.35 1.833-6.35 4.635c0 2.22 1.635 3.493 5.683 4.441l3.423.841c6.373 1.488 9 4.075 9 8.753c0 5.95-4.607 9.68-11.97 9.68c-6.89 0-11.52-3.558-11.864-9.12z"
              fill="#000"
            />
          </svg>
        </div>
      </OverlayTrigger>
      <OverlayTrigger placement="top" overlay={<Tooltip>Gatsby.js</Tooltip>}>
        <div className="skill-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            aira-hidden="true"
            focusable="false"
            width="1em"
            height="1em"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 32 32"
          >
            <path
              d="M27 16h-7v2h4.8a9.066 9.066 0 0 1-5.8 6.5L7.5 13A9 9 0 0 1 16 7a9.232 9.232 0 0 1 7.4 3.8l1.5-1.3a10.993 10.993 0 0 0-19.6 4.1l13.2 13.2A11.251 11.251 0 0 0 27 16zm-22 .1a10.682 10.682 0 0 0 3.2 7.6a10.855 10.855 0 0 0 7.6 3.2z"
              fill="#fff"
            />
            <path
              d="M16 2a14 14 0 1 0 14 14A14.041 14.041 0 0 0 16 2zM8.2 23.8A10.855 10.855 0 0 1 5 16.2L15.9 27a11.351 11.351 0 0 1-7.7-3.2zm10.2 2.9L5.3 13.6a10.993 10.993 0 0 1 19.6-4.1l-1.5 1.3A9.232 9.232 0 0 0 16 7a9.1 9.1 0 0 0-8.5 6L19 24.5a9.066 9.066 0 0 0 5.8-6.5H20v-2h7a11.031 11.031 0 0 1-8.6 10.7z"
              fill="#639"
            />
          </svg>
        </div>
      </OverlayTrigger>
      <OverlayTrigger placement="top" overlay={<Tooltip>PHP</Tooltip>}>
        <div className="skill-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            aira-hidden="true"
            focusable="false"
            width="1.9em"
            height="1em"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 256 135"
          >
            <defs>
              <radialGradient
                id="IconifyId-17aabc5ca9c-3902ec-107"
                cx=".837"
                cy="-125.811"
                r="363.057"
                gradientTransform="matrix(.463 0 0 .463 76.464 81.918)"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0" stopColor="#fff" />
                <stop offset=".5" stopColor="#4c6b97" />
                <stop offset="1" stopColor="#231f20" />
              </radialGradient>
            </defs>
            <ellipse
              fill="url(#IconifyId-17aabc5ca9c-3902ec-107)"
              cx="128"
              cy="67.3"
              rx="128"
              ry="67.3"
            />
            <ellipse fill="#6181B6" cx="128" cy="67.3" rx="123" ry="62.3" />
            <g fill="#FFF">
              <path d="M152.9 87.5l6.1-31.4c1.4-7.1.2-12.4-3.4-15.7c-3.5-3.2-9.5-4.8-18.3-4.8h-10.6l3-15.6c.1-.6 0-1.2-.4-1.7s-.9-.7-1.5-.7h-14.6c-1 0-1.8.7-2 1.6l-6.5 33.3c-.6-3.8-2-7-4.4-9.6c-4.3-4.9-11-7.4-20.1-7.4H52.1c-1 0-1.8.7-2 1.6L37 104.7c-.1.6 0 1.2.4 1.7s.9.7 1.5.7h14.7c1 0 1.8-.7 2-1.6l3.2-16.3h10.9c5.7 0 10.6-.6 14.3-1.8c3.9-1.3 7.4-3.4 10.5-6.3c2.5-2.3 4.6-4.9 6.2-7.7l-2.6 13.5c-.1.6 0 1.2.4 1.7s.9.7 1.5.7h14.6c1 0 1.8-.7 2-1.6l7.2-37h10c4.3 0 5.5.8 5.9 1.2c.3.3.9 1.5.2 5.2L134.1 87c-.1.6 0 1.2.4 1.7s.9.7 1.5.7h15c.9-.3 1.7-1 1.9-1.9zm-67.6-26c-.9 4.7-2.6 8.1-5.1 10c-2.5 1.9-6.6 2.9-12 2.9h-6.5l4.7-24.2h8.4c6.2 0 8.7 1.3 9.7 2.4c1.3 1.6 1.6 4.7.8 8.9z" />
              <path d="M215.3 42.9c-4.3-4.9-11-7.4-20.1-7.4h-28.3c-1 0-1.8.7-2 1.6l-13.1 67.5c-.1.6 0 1.2.4 1.7s.9.7 1.5.7h14.7c1 0 1.8-.7 2-1.6l3.2-16.3h10.9c5.7 0 10.6-.6 14.3-1.8c3.9-1.3 7.4-3.4 10.5-6.3c2.6-2.4 4.8-5.1 6.4-8c1.6-2.9 2.8-6.1 3.5-9.6c1.7-8.7.4-15.5-3.9-20.5zM200 61.5c-.9 4.7-2.6 8.1-5.1 10c-2.5 1.9-6.6 2.9-12 2.9h-6.5l4.7-24.2h8.4c6.2 0 8.7 1.3 9.7 2.4c1.4 1.6 1.7 4.7.8 8.9z" />
            </g>
            <g fill="#000004">
              <path d="M74.8 48.2c5.6 0 9.3 1 11.2 3.1c1.9 2.1 2.3 5.6 1.3 10.6c-1 5.2-3 9-5.9 11.2c-2.9 2.2-7.3 3.3-13.2 3.3h-8.9l5.5-28.2h10zM39 105h14.7l3.5-17.9h12.6c5.6 0 10.1-.6 13.7-1.8c3.6-1.2 6.8-3.1 9.8-5.9c2.5-2.3 4.5-4.8 6-7.5s2.6-5.7 3.2-9c1.6-8 .4-14.2-3.5-18.7s-10.1-6.7-18.6-6.7H52.1L39 105z" />
              <path d="M113.3 19.6h14.6l-3.5 17.9h13c8.2 0 13.8 1.4 16.9 4.3c3.1 2.9 4 7.5 2.8 13.9L151 87.1h-14.8l5.8-29.9c.7-3.4.4-5.7-.7-6.9c-1.1-1.2-3.6-1.9-7.3-1.9h-11.7l-7.5 38.7h-14.6l13.1-67.5z" />
              <path d="M189.5 48.2c5.6 0 9.3 1 11.2 3.1c1.9 2.1 2.3 5.6 1.3 10.6c-1 5.2-3 9-5.9 11.2c-2.9 2.2-7.3 3.3-13.2 3.3H174l5.5-28.2h10zM153.7 105h14.7l3.5-17.9h12.6c5.6 0 10.1-.6 13.7-1.8c3.6-1.2 6.8-3.1 9.8-5.9c2.5-2.3 4.5-4.8 6-7.5s2.6-5.7 3.2-9c1.6-8 .4-14.2-3.5-18.7s-10.1-6.7-18.6-6.7h-28.3L153.7 105z" />
            </g>
          </svg>
        </div>
      </OverlayTrigger>
      <OverlayTrigger placement="top" overlay={<Tooltip>WordPress</Tooltip>}>
        <div className="skill-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            aira-hidden="true"
            focusable="false"
            width="1.01em"
            height="1em"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 256 255"
          >
            <path
              d="M18.124 127.5c0 43.296 25.16 80.711 61.646 98.442L27.594 82.986a108.965 108.965 0 0 0-9.47 44.514zm183.221-5.52c0-13.517-4.856-22.879-9.02-30.165c-5.545-9.01-10.742-16.64-10.742-25.65c0-10.055 7.626-19.415 18.368-19.415c.485 0 .944.06 1.417.088c-19.46-17.829-45.387-28.714-73.863-28.714c-38.213 0-71.832 19.606-91.39 49.302c2.566.077 4.984.13 7.039.13c11.44 0 29.15-1.387 29.15-1.387c5.897-.348 6.592 8.312.702 9.01c0 0-5.926.697-12.52 1.042L100.32 194.7l23.937-71.79l-17.042-46.692c-5.89-.345-11.47-1.042-11.47-1.042c-5.894-.346-5.203-9.358.691-9.01c0 0 18.064 1.388 28.811 1.388c11.44 0 29.151-1.388 29.151-1.388c5.9-.348 6.594 8.312.702 9.01c0 0-5.938.697-12.52 1.042l39.529 117.581l10.91-36.458c4.728-15.129 8.327-25.995 8.327-35.36zm-71.921 15.088l-32.818 95.363a109.376 109.376 0 0 0 30.899 4.456c12.737 0 24.952-2.202 36.323-6.2a9.605 9.605 0 0 1-.779-1.507l-33.625-92.112zm94.058-62.045c.47 3.484.737 7.224.737 11.247c0 11.1-2.073 23.577-8.317 39.178l-33.411 96.6c32.518-18.963 54.39-54.193 54.39-94.545c.002-19.017-4.856-36.9-13.4-52.48zM127.505 0C57.2 0 0 57.196 0 127.5c0 70.313 57.2 127.507 127.505 127.507c70.302 0 127.51-57.194 127.51-127.507C255.014 57.196 197.808 0 127.506 0zm0 249.163c-67.08 0-121.659-54.578-121.659-121.663c0-67.08 54.576-121.654 121.659-121.654c67.078 0 121.652 54.574 121.652 121.654c0 67.085-54.574 121.663-121.652 121.663z"
              fill="#464342"
            />
          </svg>
        </div>
      </OverlayTrigger>
      <OverlayTrigger placement="top" overlay={<Tooltip>JavaScript</Tooltip>}>
        <div className="skill-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            aria-hidden="true"
            focusable="false"
            width="1em"
            height="1em"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 32 32"
          >
            <path
              d="M18.774 19.7a3.727 3.727 0 0 0 3.376 2.078c1.418 0 2.324-.709 2.324-1.688c0-1.173-.931-1.589-2.491-2.272l-.856-.367c-2.469-1.052-4.11-2.37-4.11-5.156c0-2.567 1.956-4.52 5.012-4.52A5.058 5.058 0 0 1 26.9 10.52l-2.665 1.711a2.327 2.327 0 0 0-2.2-1.467a1.489 1.489 0 0 0-1.638 1.467c0 1.027.636 1.442 2.1 2.078l.856.366c2.908 1.247 4.549 2.518 4.549 5.376c0 3.081-2.42 4.769-5.671 4.769a6.575 6.575 0 0 1-6.236-3.5zM6.686 20c.538.954 1.027 1.76 2.2 1.76c1.124 0 1.834-.44 1.834-2.15V7.975h3.422v11.683c0 3.543-2.078 5.156-5.11 5.156A5.312 5.312 0 0 1 3.9 21.688z"
              fill="#f5de19"
            />
          </svg>
        </div>
      </OverlayTrigger>
      <OverlayTrigger placement="top" overlay={<Tooltip>HTML5</Tooltip>}>
        <div className="skill-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            aira-hidden="true"
            focusable="false"
            width="1em"
            height="1em"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 32 32"
          >
            <path
              fill="#e44f26"
              d="M5.902 27.201L3.655 2h24.69l-2.25 25.197L15.985 30L5.902 27.201z"
            />
            <path
              fill="#f1662a"
              d="M16 27.858l8.17-2.265l1.922-21.532H16v23.797z"
            />
            <path
              fill="#ebebeb"
              d="M16 13.407h-4.09l-.282-3.165H16V7.151H8.25l.074.83l.759 8.517H16v-3.091z"
            />
            <path
              fill="#ebebeb"
              d="M16 21.434l-.014.004l-3.442-.929l-.22-2.465H9.221l.433 4.852l6.332 1.758l.014-.004v-3.216z"
            />
            <path
              fill="#fff"
              d="M15.989 13.407v3.091h3.806l-.358 4.009l-3.448.93v3.216l6.337-1.757l.046-.522l.726-8.137l.076-.83H15.989z"
            />
            <path
              fill="#fff"
              d="M15.989 7.151V10.242h7.466l.062-.694l.141-1.567l.074-.83h-7.743z"
            />
          </svg>
        </div>
      </OverlayTrigger>
      <OverlayTrigger placement="top" overlay={<Tooltip>CSS3</Tooltip>}>
        <div className="skill-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            aira-hidden="true"
            focusable="false"
            width="1em"
            height="1em"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 32 32"
          >
            <path
              fill="#1572b6"
              d="M5.902 27.201L3.656 2h24.688l-2.249 25.197L15.985 30L5.902 27.201z"
            />
            <path
              fill="#33a9dc"
              d="M16 27.858l8.17-2.265l1.922-21.532H16v23.797z"
            />
            <path
              fill="#fff"
              d="M16 13.191h4.09l.282-3.165H16V6.935h7.75l-.074.829l-.759 8.518H16v-3.091z"
            />
            <path
              fill="#ebebeb"
              d="M16.019 21.218l-.014.004l-3.442-.93l-.22-2.465H9.24l.433 4.853l6.331 1.758l.015-.004v-3.216z"
            />
            <path
              fill="#fff"
              d="M19.827 16.151l-.372 4.139l-3.447.93v3.216l6.336-1.756l.047-.522l.537-6.007h-3.101z"
            />
            <path
              fill="#ebebeb"
              d="M16.011 6.935v3.091H8.545l-.062-.695l-.141-1.567l-.074-.829h7.743z"
            />
            <path
              fill="#ebebeb"
              d="M16 13.191v3.091H12.601l-.062-.695l-.14-1.567l-.074-.829H16z"
            />
          </svg>
        </div>
      </OverlayTrigger>
      <OverlayTrigger placement="top" overlay={<Tooltip>SASS</Tooltip>}>
        <div className="skill-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            aira-hidden="true"
            focusable="false"
            width="1.34em"
            height="1em"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 256 192"
          >
            <path
              d="M220.281 110.514c-8.906.046-16.647 2.191-23.128 5.362c-2.379-4.71-4.757-8.906-5.176-11.984c-.467-3.59-1.026-5.782-.467-10.072c.56-4.29 3.078-10.399 3.031-10.865c-.046-.466-.56-2.658-5.689-2.704c-5.129-.047-9.559.979-10.072 2.331c-.513 1.352-1.492 4.43-2.145 7.6c-.886 4.664-10.258 21.31-15.62 30.03c-1.726-3.403-3.218-6.388-3.545-8.766c-.466-3.59-1.026-5.782-.466-10.072c.56-4.29 3.078-10.398 3.031-10.865c-.047-.466-.56-2.658-5.689-2.704c-5.13-.047-9.56.979-10.072 2.331c-.513 1.353-1.073 4.523-2.145 7.601c-1.073 3.078-13.523 30.87-16.787 38.05a214.726 214.726 0 0 1-4.15 8.627s-.047.14-.187.373a117.773 117.773 0 0 1-1.398 2.658v.046c-.7 1.26-1.446 2.425-1.819 2.425c-.28 0-.793-3.357.093-7.927c1.865-9.652 6.295-24.667 6.249-25.18c0-.28.839-2.891-2.891-4.244c-3.638-1.352-4.943.886-5.27.886c-.326 0-.56.793-.56.793s4.058-16.88-7.74-16.88c-7.367 0-17.533 8.067-22.569 15.341a6269.96 6269.96 0 0 0-17.16 9.373c-2.75 1.539-5.595 3.078-8.253 4.523c-.187-.186-.373-.42-.56-.606c-14.269-15.248-40.661-26.02-39.542-46.49c.42-7.461 2.984-27.046 50.687-50.827c39.262-19.352 70.505-13.99 75.914-2.099c7.74 16.974-16.74 48.496-57.309 53.065c-15.481 1.726-23.595-4.243-25.646-6.481c-2.145-2.332-2.472-2.472-3.265-2.005c-1.305.7-.466 2.798 0 4.01c1.213 3.17 6.202 8.766 14.642 11.518c7.461 2.424 25.6 3.777 47.563-4.71c24.574-9.513 43.786-35.952 38.144-58.101c-5.643-22.476-42.947-29.89-78.246-17.347C61.086 13.99 38.33 25.74 21.963 41.035C2.518 59.22-.56 75.028.699 81.65c4.524 23.501 36.932 38.796 49.895 50.127c-.653.373-1.26.7-1.772.98c-6.482 3.217-31.196 16.133-37.351 29.796c-6.994 15.481 1.12 26.58 6.482 28.071c16.647 4.617 33.76-3.683 42.946-17.393c9.186-13.709 8.067-31.522 3.824-39.682c-.047-.093-.093-.187-.187-.28c1.679-.979 3.404-2.005 5.083-2.984a247.933 247.933 0 0 1 9.373-5.27c-1.586 4.337-2.752 9.513-3.311 16.974c-.7 8.767 2.89 20.144 7.6 24.62c2.099 1.96 4.57 2.006 6.156 2.006c5.502 0 7.974-4.57 10.725-9.979c3.357-6.621 6.388-14.315 6.388-14.315s-3.777 20.797 6.482 20.797c3.73 0 7.507-4.85 9.186-7.321v.046s.093-.14.28-.466c.373-.606.606-.98.606-.98v-.092c1.492-2.612 4.85-8.534 9.839-18.373c6.435-12.683 12.637-28.537 12.637-28.537s.56 3.87 2.471 10.305c1.12 3.777 3.45 7.927 5.316 11.937c-1.492 2.099-2.425 3.264-2.425 3.264l.047.047c-1.213 1.585-2.518 3.31-3.964 4.99c-5.083 6.061-11.144 13.01-11.984 15.014c-.98 2.378-.746 4.104 1.12 5.503c1.352 1.026 3.776 1.165 6.248 1.026c4.57-.327 7.787-1.446 9.372-2.145c2.472-.886 5.363-2.239 8.067-4.244c4.99-3.684 8.02-8.953 7.741-15.9c-.14-3.824-1.399-7.648-2.938-11.239c.467-.652.886-1.305 1.353-1.958c7.88-11.518 13.989-24.155 13.989-24.155s.56 3.87 2.471 10.306c.933 3.264 2.845 6.808 4.523 10.258c-7.414 6.016-11.984 13.01-13.616 17.58c-2.937 8.487-.653 12.31 3.684 13.196c1.958.42 4.756-.513 6.808-1.399c2.611-.839 5.689-2.284 8.627-4.43c4.99-3.683 9.792-8.813 9.512-15.76c-.14-3.171-.979-6.296-2.145-9.327c6.295-2.61 14.409-4.056 24.76-2.844c22.197 2.611 26.58 16.46 25.74 22.29c-.839 5.828-5.502 8.999-7.04 9.978c-1.54.98-2.052 1.306-1.912 2.005c.186 1.026.932.98 2.238.793c1.819-.326 11.658-4.71 12.077-15.435c.7-13.709-12.357-28.677-35.439-28.537zM49.055 168.242c-7.368 8.02-17.626 11.051-22.056 8.487c-4.756-2.752-2.891-14.596 6.155-23.082c5.502-5.176 12.59-9.98 17.3-12.917c1.072-.653 2.658-1.585 4.57-2.751c.326-.187.513-.28.513-.28l1.119-.7c3.31 12.124.14 22.803-7.601 31.243zm53.625-36.465c-2.565 6.249-7.927 22.243-11.191 21.357c-2.798-.746-4.524-12.87-.56-24.854c2.005-6.016 6.248-13.197 8.72-15.994c4.01-4.477 8.44-5.97 9.512-4.15c1.353 2.378-4.896 19.724-6.481 23.641zm44.252 21.17c-1.073.56-2.098.933-2.565.653c-.326-.187.467-.933.467-.933s5.549-5.968 7.74-8.673c1.26-1.585 2.751-3.45 4.337-5.549v.606c0 7.135-6.902 11.938-9.98 13.896zm34.133-7.787c-.793-.56-.653-2.425 2.005-8.254c1.026-2.285 3.45-6.108 7.601-9.792c.466 1.492.793 2.938.746 4.29c-.047 9-6.481 12.357-10.352 13.756z"
              fill="#CD6799"
            />
          </svg>
        </div>
      </OverlayTrigger>
      <OverlayTrigger placement="top" overlay={<Tooltip>Apollo</Tooltip>}>
        <div className="skill-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            aira-hidden="true"
            focusable="false"
            width="1em"
            height="1em"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 256 256"
          >
            <path
              d="M160.227 178.519h27.63L143.75 64.049h-30.549l-44.107 114.47h27.632l7.208-19.39h41.675l-7.544-21.456h-27.44l17.85-49.254l31.752 90.1zm91.112-84.751a6.641 6.641 0 0 0-8.185-4.627a6.648 6.648 0 0 0-4.628 8.183A114.646 114.646 0 0 1 242.704 128c0 63.248-51.456 114.702-114.704 114.702c-63.248 0-114.703-51.454-114.703-114.702C13.297 64.751 64.752 13.296 128 13.296c26.793 0 52.718 9.518 73.179 26.456a15.938 15.938 0 0 0-1.238 6.173c0 8.835 7.162 15.997 15.997 15.997s15.997-7.162 15.997-15.997s-7.162-15.997-15.997-15.997c-1.701 0-3.338.271-4.876.763C188.022 11.056 158.513 0 128 0C57.421 0 0 57.42 0 128c0 70.579 57.421 127.999 128 127.999c70.579 0 128-57.42 128-127.999a127.95 127.95 0 0 0-4.661-34.232z"
              fill="#112B49"
            />
          </svg>
        </div>
      </OverlayTrigger>
      <OverlayTrigger placement="top" overlay={<Tooltip>Redux</Tooltip>}>
        <div className="skill-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            aira-hidden="true"
            focusable="false"
            width="1.05em"
            height="1em"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 256 244"
          >
            <path
              d="M177.381 169.733c9.447-.978 16.614-9.122 16.288-18.896c-.325-9.773-8.47-17.592-18.243-17.592h-.651c-10.1.326-17.918 8.796-17.592 18.895c.326 4.887 2.28 9.122 5.212 12.054c-11.076 21.828-28.016 37.791-53.426 51.148c-17.266 9.122-35.183 12.38-53.1 10.1c-14.66-1.955-26.062-8.47-33.23-19.222c-10.424-15.963-11.401-33.23-2.605-50.496c6.19-12.38 15.962-21.502 22.152-26.063c-1.303-4.235-3.258-11.402-4.235-16.614c-47.237 34.207-42.35 80.468-28.016 102.295c10.75 16.29 32.577 26.389 56.684 26.389c6.515 0 13.03-.652 19.546-2.28c41.699-8.145 73.299-32.905 91.216-69.718zm57.336-40.397c-24.759-28.995-61.245-44.958-102.944-44.958h-5.212c-2.932-5.864-9.122-9.774-15.963-9.774h-.652C99.848 74.93 92.03 83.4 92.355 93.5c.326 9.773 8.47 17.592 18.243 17.592h.651c7.167-.326 13.357-4.887 15.963-11.077h5.864c24.759 0 48.214 7.167 69.39 21.176c16.288 10.751 28.016 24.76 34.531 41.7c5.538 13.683 5.212 27.04-.652 38.443c-9.121 17.266-24.432 26.714-44.63 26.714c-13.031 0-25.41-3.91-31.926-6.842c-3.583 3.258-10.099 8.47-14.66 11.729c14.009 6.515 28.343 10.099 42.025 10.099c31.274 0 54.404-17.267 63.2-34.533c9.447-18.896 8.795-51.474-15.637-79.165zM69.225 175.27c.326 9.774 8.47 17.592 18.243 17.592h.652c10.099-.325 17.917-8.796 17.591-18.895c-.325-9.774-8.47-17.592-18.243-17.592h-.651c-.652 0-1.63 0-2.28.325c-13.357-22.153-18.895-46.26-16.94-72.323c1.302-19.547 7.818-36.488 19.22-50.497c9.447-12.054 27.69-17.918 40.07-18.243c34.531-.652 49.19 42.351 50.168 59.618c4.235.977 11.402 3.258 16.289 4.887C189.434 27.366 156.857 0 125.584 0c-29.32 0-56.359 21.176-67.11 52.451c-14.985 41.7-5.212 81.771 13.031 113.372c-1.628 2.28-2.606 5.864-2.28 9.448z"
              fill="#764ABC"
            />
          </svg>
        </div>
      </OverlayTrigger>
      <OverlayTrigger placement="top" overlay={<Tooltip>jQuery</Tooltip>}>
        <div className="skill-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            aira-hidden="true"
            focusable="false"
            width="4.42em"
            height="1em"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 512 116"
          >
            <g fill="none" fillRule="evenodd">
              <path
                d="M489.718 8.646l21.42.118s-39.824 53.964-43.076 58.362c-1.056 1.424-2.66 2.96-3.474 4.864c-2.057 4.786-4.169 15.285-4.169 15.285l-19.599.098s3.05-10.944 2.924-16.773c-.11-5.092-2.71-10.178-4.168-15.285c-1.474-5.17-3.475-15.286-3.475-15.286h20.15l2.779 11.117l30.688-42.5"
                fill="#1A1918"
              />
              <path
                d="M449.157 20.027c3.953 2.383 6.379 15.529 6.379 15.529s-20.684.305-31.94.305h-9.727l-11.812 51.414h-18.064s11.242-55.874 13.896-66.004c.86-3.28 5.892-2.717 14.389-2.717h13.569c8.762 0 19.003-1.119 23.31 1.473"
                fill="#1A1918"
              />
              <path
                d="M365.06 45.067s.563-3.3-1.91-7.122c-2.113-3.258-4.064-4.016-9.623-4.19c-15.695-.493-15.39 11.138-15.39 11.138l26.923.174zm17.022-13.32c2.3 8.297-2.084 27.792-2.084 27.792s-22.894-.382-35.434 0c-3.899.119-8.566-.424-9.727 1.39c-1.633 2.542.597 6.455 2.487 8.108c2.175 1.903 6.412 2.12 7.935 2.313c10.178 1.293 31.48.334 31.48.334l-3.69 16.34s-30.103 1.51-45.16-2.084c-2.973-.708-5.76-2.139-7.643-4.168c-.514-.555-.96-1.312-1.446-1.966c-.388-.522-1.52-2.237-2.028-3.593c-3.439-9.164.403-26.72 4.169-36.128c.437-1.09.986-2.473 1.564-3.648c.722-1.465 1.333-3.119 1.91-3.995c.388-.604.869-.993 1.272-1.563c.465-.674 1.006-1.327 1.507-1.91c1.39-1.612 2.967-2.752 4.864-4.168c6.273-4.698 17.626-8.345 31.265-6.949c5.135.528 12.89 2.362 16.675 7.643c1.014 1.41 1.515 4.21 2.084 6.253z"
                fill="#1A1918"
              />
              <path
                d="M299.229 18.49l17.516-.103s-9.762 46.307-14.737 68.888h-20.15c-14.082 0-26.623 1.744-31.959-8.338c-5.176-9.789-.236-25.887 2.084-36.824c1.64-7.74 5.094-23.56 5.094-23.56l18.148-.166s-5.128 24.63-7.262 36.928c-.764 4.405-2.34 8.553-.694 11.81c1.563 3.1 3.752 3.322 10.421 3.475c2.113.05 9.033 0 9.033 0l12.506-52.11"
                fill="#1A1918"
              />
              <path
                d="M217.244 51.84c1.834-6.516 4.509-13.582 4.169-19.454c-.368-6.28-5.634-11.998-9.032-13.2c-10.234-3.613-19.815 1.438-23.623 5.558c-4.926 5.336-6.594 11.569-8.338 20.15c-1.298 6.37-2.362 13.095 0 18.063c4.182 8.783 17.224 6.865 31.266 6.949c2.084-5.586 3.807-11.86 5.558-18.066zm24.318-25.706c2 14.548-5.676 30.606-10.964 44.57c5.392.487 10.117-.075 10.457.327c.354.521-3.614 16.668-4.997 16.71c-4.279.111-18.459.229-24.372.229c-19.295 0-37.345 1.257-46.55-8.337c-3.738-3.898-6.323-10.583-6.949-15.286c-1.042-7.851.264-16.495 2.085-23.622c1.647-6.435 3.758-12.507 6.948-18.066C175.328 8.507 189.432-1.998 213.075.427c4.586.472 11.172 2.48 15.286 4.863c.284.167 1.279.959 1.507 1.098c5.559 3.537 10.624 11.978 11.694 19.746z"
                fill="#1A1918"
              />
              <path
                d="M156.193 18.574c-1.167 5.315-2.334 11.34-3.564 16.592h-19.454c1.507-5.822 2.661-11.61 4.169-16.675c6.225 0 12.013.083 18.85.083"
                fill="#1A1918"
              />
              <path
                d="M132.48 40.03h18.76c-2.453 13.576-7.31 35.475-11.117 50.719c-2.383 9.54-3.974 16.501-10.422 21.538c-.577.452-.91.237-1.39.695c-1.188 1.133-6.684 2.447-9.726 2.779c-4.947.536-10.54.07-16.62-.055c1.591-5.815 3.391-12.798 4.809-18.01c14.82 1.794 15.195-12.214 18.064-25.706c1.66-7.796 6.691-28.834 7.642-31.96"
                fill="#1A1918"
              />
              <g fill="#21609B">
                <path d="M88.708 75.464l-.402 1.042c-6.85 13.34-18.989 21.524-36.303 21.885c-8.094.167-15.806-1.91-20.844-4.168C20.287 89.338 11.142 80.279 6.148 70.6c-7.164-13.875-8.456-33.176 6.44-47.592c.23 0-1.807 3.126-1.577 3.126l-.41 1.334C-.133 61.074 32.938 89.874 65.086 86.58c7.726-.792 17.578-5.023 23.622-11.116" />
                <path d="M69.254 61.568c8.088.055 16.536-3.725 21.539-9.032c-4.377 11.11-17.05 18.251-34.044 15.98c-14.23-1.904-27.785-16.223-29.181-30.571c-1.021-10.442 2.618-16.674 8.615-24.234c-2.084 3.954-2.863 7.003-3.057 8.948c-2.278 22.588 18.044 38.79 36.128 38.909" />
                <path d="M89.98 33.512c-1.257 2.884-8.496 8.33-11.693 9.011c-12.659 2.697-20.766-3.306-25.013-10.137c-.631-1.02-1.798-3.806-2.007-4.515c-1.647-5.6-.89-14.07 4.023-18.454c-1.48 4.169-1.696 9.011-.917 12.159c.472 1.903 1.91 5.226 3.349 7.316c2.618 3.807 4.279 4.732 7.642 6.754c1.515.91 3.14 1.64 3.842 1.84c3.189.939 9.922 3.412 20.775-3.974" />
              </g>
            </g>
          </svg>
        </div>
      </OverlayTrigger>
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip>Styled Components</Tooltip>}
      >
        <div className="skill-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            aira-hidden="true"
            focusable="false"
            width="1em"
            height="1em"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 32 32"
          >
            <path
              d="M18.05 29.6c.042-.095.148-.161.225-.241c1.175-1.232 2.36-2.453 3.519-3.7A3.2 3.2 0 0 0 22.808 23a5.925 5.925 0 0 0-.143-.624c-.316.3-.61.573-.906.848c-.46.428-.918.858-1.382 1.281a1.931 1.931 0 0 1-2.148.419a1.973 1.973 0 0 1-1.29-1.75a1.04 1.04 0 0 0-.043-.146c-.353.3-.691.576-1.026.86l-6.963 5.9c-.048.041-.1.092-.145.132h9.283l-.014-.009c-.05-.035-.024-.219.019-.311z"
              fill="#ffcebf"
            />
            <path
              d="M8.337 29.6a1.239 1.239 0 0 1 .295-.276l9.636-8.175q.986-.837 1.963-1.683a.523.523 0 0 0 .182-.224a5.364 5.364 0 0 0 .065-2.069c-.1.07-.154.1-.2.149c-.789.706-1.574 1.418-2.367 2.12a1.762 1.762 0 0 1-2.048.329a1.889 1.889 0 0 1-1.08-1.807v-.324c-.145.106-.251.177-.35.257q-5.785 4.632-11.568 9.257c-.174.139-.382.449-.61.148s.119-.425.294-.565q6.165-4.947 12.336-9.885c.67-.537.714-.762.278-1.615l-.26.244c-.713.663-1.434 1.317-2.136 1.991a2.121 2.121 0 0 1-3.585-1.337c-.133.1-.248.173-.357.258l-6.1 4.728a1.485 1.485 0 0 1-.356.258a.446.446 0 0 1-.3-.015v8.561h6.256a.365.365 0 0 1 .012-.325z"
              fill="#ffcebf"
            />
            <path
              d="M25.237 2.423c-.17.557-.335 1.115-.484 1.678a1.688 1.688 0 0 0 .9 2.09a7.122 7.122 0 0 0 3.818.8V2.518a.73.73 0 0 1 .016-.294a.666.666 0 0 1 .105-.149h-4.359c.067.078.044.215.004.348z"
              fill="#ff6196"
            />
            <path
              d="M16.482 12.032a2.422 2.422 0 0 1-.5 1.376a22.671 22.671 0 0 1-3.726 3.792a1.442 1.442 0 0 1-1.684.2a1.393 1.393 0 0 1-.843-1.368a1.624 1.624 0 0 1 .417-.947a35.848 35.848 0 0 1 5.019-3.993a.71.71 0 0 1 .829-.034a1.041 1.041 0 0 1 .488.974z"
              fill="#ff87af"
            />
            <path
              d="M15.284 18.093a1.437 1.437 0 0 1 .448-1.2a38.336 38.336 0 0 1 4.87-3.813c.052-.033.1-.066.157-.1a.837.837 0 0 1 1.025.035a.861.861 0 0 1 .242.979a4.39 4.39 0 0 1-1.168 1.908a118.836 118.836 0 0 1-3.4 3.22a1.124 1.124 0 0 1-1.364.192a1.512 1.512 0 0 1-.81-1.221z"
              fill="#ff87af"
            />
            <path
              d="M22.5 18.754c-.28.3-.568.586-.837.893a1.89 1.89 0 0 0-.2.38c.148.044.321.16.441.119c.611-.205 1.207-.451 1.878-.71c-.146.336-.256.646-.411.93A12.189 12.189 0 0 1 21 23.238q-.532.513-1.105.981a1.484 1.484 0 0 1-2.415-.92a1.1 1.1 0 0 1 .238-.813a22.187 22.187 0 0 1 4.623-3.823a.193.193 0 0 1 .065-.013z"
              fill="#ff87af"
            />
            <path
              d="M24.794 14.771l1.711-7.6l1.2.281l-.619 1.881c-.578 1.75-1.163 3.5-1.727 5.252c-.11.324-.254.384-.565.186z"
              fill="#ff6196"
            />
            <path
              d="M22.862 19.241c.181-.691.361-1.33.513-1.976a4.468 4.468 0 0 1 .826-1.721c.243-.319.516-.192.795-.123c.258.063.323.252.334.5a2.845 2.845 0 0 1-.588 1.907a4.8 4.8 0 0 1-1.88 1.413z"
              fill="#ff6196"
            />
            <path
              d="M29.993 2.894a3.623 3.623 0 0 0-.017-.668a.291.291 0 0 0-.116-.151a.381.381 0 0 0-.152-.075c-.032-.006-.077.027-.12.074a.666.666 0 0 0-.105.149a.73.73 0 0 0-.016.294v4.472a7.122 7.122 0 0 1-3.818-.8a1.688 1.688 0 0 1-.9-2.09c.149-.563.314-1.121.484-1.678c.04-.133.063-.27 0-.348a.2.2 0 0 0-.135-.064a.3.3 0 0 0-.182.064a.434.434 0 0 0-.171.19c-.2.6-.376 1.206-.529 1.818a2.148 2.148 0 0 0-.046.737a2.339 2.339 0 0 0 1.542 2c.189.079.3.157.247.406c-.073.316-.144.632-.216.949q-.735 3.222-1.462 6.447a.483.483 0 0 1-.121.257a3.228 3.228 0 0 0-.791.92a4.8 4.8 0 0 0-.53 1.5a.981.981 0 0 1-.558.785c-.417.211-.8.484-1.263.768A12.639 12.639 0 0 0 21 17.179a1.062 1.062 0 0 1 .284-.96a4.75 4.75 0 0 0 1.258-2.194a1.294 1.294 0 0 0-1.208-1.7a1.7 1.7 0 0 0-.929.264a68.767 68.767 0 0 0-2.812 2.026c-.547.412-1.062.868-1.592 1.3a.418.418 0 0 1-.059-.081a.842.842 0 0 0-.059-.214c-.443-.684-.136-1.181.345-1.692A2.793 2.793 0 0 0 17 11.977a1.568 1.568 0 0 0-.327-1.026a1.459 1.459 0 0 0-.438-.363a1.337 1.337 0 0 0-1.517.162l-.279.2c-.637.456-1.282.9-1.895 1.388a64.278 64.278 0 0 0-2.626 2.214c-.4.353-.692.835-1.107 1.163c-2.164 1.709-4.351 3.387-6.53 5.076a1.022 1.022 0 0 0-.205.161a.164.164 0 0 0-.016.029c-.046.107-.085.284-.031.349a.141.141 0 0 0 .047.033a.446.446 0 0 0 .3.015a1.485 1.485 0 0 0 .356-.258l6.1-4.728c.109-.085.224-.162.357-.258a2.121 2.121 0 0 0 3.585 1.337c.7-.674 1.423-1.328 2.136-1.991l.26-.244c.436.853.392 1.078-.278 1.615q-6.176 4.942-12.343 9.886c-.175.14-.521.267-.294.565s.436-.009.61-.148q5.786-4.621 11.564-9.254c.1-.08.205-.151.35-.257v.324a1.889 1.889 0 0 0 1.08 1.807a1.762 1.762 0 0 0 2.048-.329c.793-.7 1.578-1.414 2.367-2.12c.05-.045.108-.079.2-.149a5.364 5.364 0 0 1-.065 2.069a.523.523 0 0 1-.182.224q-.978.845-1.963 1.683l-9.632 8.176a1.239 1.239 0 0 0-.295.276a.365.365 0 0 0-.012.321a.376.376 0 0 0 .32.063a.294.294 0 0 0 .116-.065c.05-.04.1-.091.145-.132l6.963-5.9c.335-.284.673-.564 1.026-.86a1.04 1.04 0 0 1 .043.146a1.973 1.973 0 0 0 1.29 1.75a1.931 1.931 0 0 0 2.148-.419c.464-.423.922-.853 1.382-1.281c.3-.275.59-.551.906-.848a5.925 5.925 0 0 1 .143.624a3.2 3.2 0 0 1-1.014 2.649c-1.159 1.248-2.344 2.469-3.519 3.7c-.077.08-.183.146-.225.241s-.069.281-.019.321l.014.009a.573.573 0 0 0 .338.051a.136.136 0 0 0 .081-.051c.028-.029.055-.065.082-.092c.952-.984 1.909-1.963 2.854-2.954a13.982 13.982 0 0 0 1.074-1.223a3.411 3.411 0 0 0 .61-3.616a.516.516 0 0 1 .074-.386c.065-.112.137-.221.211-.329a4.632 4.632 0 0 0 .587-1a7.547 7.547 0 0 1 1.339-2.4a2.792 2.792 0 0 0 .5-2.469a.988.988 0 0 1 0-.489c.506-1.567 1.027-3.129 1.543-4.692l.69-2.094l.213-.647c.454 0 .882-.009 1.308 0c.354.01.462-.156.458-.5c-.021-1.38-.013-2.759-.013-4.138zM12.256 17.2a1.442 1.442 0 0 1-1.684.2a1.393 1.393 0 0 1-.843-1.368a1.624 1.624 0 0 1 .417-.947a35.848 35.848 0 0 1 5.019-3.993a.852.852 0 0 1 .326-.14a.656.656 0 0 1 .238 0a.763.763 0 0 1 .265.106a1.041 1.041 0 0 1 .488.975a2.422 2.422 0 0 1-.5 1.376a22.671 22.671 0 0 1-3.726 3.791zm5.2 1.929a1.124 1.124 0 0 1-1.364.192a1.512 1.512 0 0 1-.81-1.224a1.437 1.437 0 0 1 .448-1.2a38.336 38.336 0 0 1 4.87-3.813c.052-.033.1-.066.157-.1a.837.837 0 0 1 1.025.035a.861.861 0 0 1 .242.979a4.39 4.39 0 0 1-1.168 1.908c-1.103 1.102-2.25 2.163-3.398 3.219zm5.911 1.241A12.189 12.189 0 0 1 21 23.238q-.532.513-1.105.981a1.484 1.484 0 0 1-2.415-.92a1.1 1.1 0 0 1 .238-.813a22.187 22.187 0 0 1 4.623-3.823a.193.193 0 0 1 .065-.013l.1.1c-.28.3-.568.586-.837.893a1.89 1.89 0 0 0-.2.38c.148.044.321.16.441.119c.483-.162.958-.35 1.467-.55l.411-.16c-.154.34-.264.65-.419.934zm1.373-2.535a4.363 4.363 0 0 1-1.373 1.152q-.247.138-.507.258c.178-.681.356-1.312.507-1.95l.006-.026a4.468 4.468 0 0 1 .826-1.721c.243-.319.516-.192.795-.123c.258.063.323.252.334.5a2.845 2.845 0 0 1-.586 1.906zm2.34-8.5c-.578 1.75-1.163 3.5-1.727 5.252c-.106.329-.25.389-.561.191l1.483-6.593l.228-1.012l1.2.281l-.241.731z"
              fill="#000"
            />
          </svg>
        </div>
      </OverlayTrigger>
      <OverlayTrigger placement="top" overlay={<Tooltip>Bootstrap</Tooltip>}>
        <div className="skill-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            aira-hidden="true"
            focusable="false"
            width="1em"
            height="1em"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 256 256"
          >
            <path
              d="M0 222.991C0 241.223 14.779 256 33.009 256H222.99C241.223 256 256 241.221 256 222.991V33.01C256 14.777 241.221 0 222.991 0H33.01C14.777 0 0 14.779 0 33.009V222.99z"
              fill="#563D7C"
            />
            <path
              d="M106.158 113.238V76.985h31.911c3.04 0 5.97.253 8.792.76c2.822.506 5.319 1.41 7.49 2.713c2.17 1.303 3.907 3.112 5.21 5.427c1.302 2.316 1.954 5.283 1.954 8.9c0 6.513-1.954 11.217-5.862 14.111c-3.907 2.895-8.9 4.342-14.979 4.342h-34.516zM72.075 50.5v155h75.112c6.947 0 13.713-.868 20.298-2.605c6.585-1.737 12.446-4.414 17.584-8.032c5.137-3.618 9.226-8.286 12.265-14.002c3.04-5.717 4.559-12.483 4.559-20.298c0-9.697-2.352-17.982-7.055-24.856c-4.704-6.875-11.832-11.687-21.384-14.437c6.947-3.328 12.194-7.598 15.74-12.808c3.545-5.21 5.318-11.722 5.318-19.538c0-7.236-1.194-13.314-3.582-18.235c-2.388-4.92-5.753-8.864-10.095-11.831c-4.341-2.967-9.551-5.102-15.63-6.404c-6.078-1.303-12.808-1.954-20.189-1.954H72.075zm34.083 128.515v-42.549h37.121c7.381 0 13.315 1.7 17.802 5.102c4.486 3.401 6.73 9.081 6.73 17.041c0 4.053-.688 7.381-2.063 9.986c-1.375 2.605-3.22 4.668-5.536 6.187c-2.315 1.52-4.993 2.605-8.032 3.257c-3.04.65-6.223.976-9.552.976h-36.47z"
              fill="#FFF"
            />
          </svg>
        </div>
      </OverlayTrigger>
      <OverlayTrigger placement="top" overlay={<Tooltip>Material UI</Tooltip>}>
        <div className="skill-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            aira-hidden="true"
            focusable="false"
            width="1.26em"
            height="1em"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 256 204"
          >
            <path
              fill="#00B0FF"
              d="M0 110.848V0l96 55.424v36.95l-64-36.95v73.899z"
            />
            <path
              fill="#0081CB"
              d="M96 55.424L192 0v110.848l-64 36.95l-32-18.475l64-36.95V55.424l-64 36.95z"
            />
            <path fill="#00B0FF" d="M96 129.323v36.949l64 36.95v-36.95z" />
            <path
              d="M160 203.221l96-55.424V73.9l-32 18.474v36.95l-64 36.949v36.95zm64-147.797v-36.95L256 0v36.95l-32 18.474z"
              fill="#0081CB"
            />
          </svg>
        </div>
      </OverlayTrigger>
      <OverlayTrigger placement="top" overlay={<Tooltip>Ant Design</Tooltip>}>
        <div className="skill-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            aira-hidden="true"
            focusable="false"
            width="1em"
            height="1em"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 256 256"
          >
            <defs>
              <linearGradient
                x1="62.102%"
                y1="0%"
                x2="108.197%"
                y2="37.864%"
                id="IconifyId-17aabcd0bc1-73501e-170"
              >
                <stop stopColor="#4285EB" offset="0%" />
                <stop stopColor="#2EC7FF" offset="100%" />
              </linearGradient>
              <linearGradient
                x1="69.644%"
                y1="0%"
                x2="54.043%"
                y2="108.457%"
                id="IconifyId-17aabcd0bc1-73501e-171"
              >
                <stop stopColor="#29CDFF" offset="0%" />
                <stop stopColor="#148EFF" offset="37.86%" />
                <stop stopColor="#0A60FF" offset="100%" />
              </linearGradient>
              <linearGradient
                x1="69.691%"
                y1="-12.974%"
                x2="16.723%"
                y2="117.391%"
                id="IconifyId-17aabcd0bc1-73501e-172"
              >
                <stop stopColor="#FA816E" offset="0%" />
                <stop stopColor="#F74A5C" offset="41.473%" />
                <stop stopColor="#F51D2C" offset="100%" />
              </linearGradient>
              <linearGradient
                x1="68.128%"
                y1="-35.691%"
                x2="30.44%"
                y2="114.943%"
                id="IconifyId-17aabcd0bc1-73501e-173"
              >
                <stop stopColor="#FA8E7D" offset="0%" />
                <stop stopColor="#F74A5C" offset="51.264%" />
                <stop stopColor="#F51D2C" offset="100%" />
              </linearGradient>
            </defs>
            <g fillRule="nonzero" fill="none">
              <path
                d="M116.85 4.545L4.53 116.775a15.396 15.396 0 0 0 0 21.812L116.85 250.816c6.039 6.033 15.792 6.033 21.83 0l47.095-47.056c5.408-5.404 5.408-14.165 0-19.568c-5.408-5.404-14.176-5.404-19.584 0l-35.702 35.672c-1.503 1.502-3.784 1.502-5.287 0l-89.696-89.622c-1.503-1.502-1.503-3.781 0-5.283l89.696-89.623c1.503-1.501 3.784-1.501 5.287 0l35.702 35.673c5.408 5.404 14.176 5.404 19.584 0c5.408-5.404 5.408-14.164 0-19.568l-47.09-47.05c-6.063-5.904-15.82-5.856-21.835.154z"
                fill="url(#IconifyId-17aabcd0bc1-73501e-170)"
              />
              <path
                d="M116.85 4.545L4.53 116.775a15.396 15.396 0 0 0 0 21.812L116.85 250.816c6.039 6.033 15.792 6.033 21.83 0l47.095-47.056c5.408-5.404 5.408-14.165 0-19.568c-5.408-5.404-14.176-5.404-19.584 0l-35.702 35.672c-1.503 1.502-3.784 1.502-5.287 0l-89.696-89.622c-1.503-1.502-1.503-3.781 0-5.283l89.696-89.623c3.742-3.226 9.849-9.76 18.815-11.29c6.664-1.135 13.95 1.365 21.857 7.5L138.686 4.39c-6.064-5.903-15.82-5.855-21.836.155z"
                fill="url(#IconifyId-17aabcd0bc1-73501e-171)"
              />
              <path
                d="M196.647 173.754c5.408 5.404 14.176 5.404 19.584 0l34.739-34.71a15.396 15.396 0 0 0 0-21.812l-35.041-34.89c-5.421-5.397-14.192-5.389-19.603.018c-5.408 5.404-5.408 14.164 0 19.568l23.667 23.648c1.503 1.502 1.503 3.781 0 5.283l-23.346 23.327c-5.408 5.404-5.408 14.165 0 19.568z"
                fill="url(#IconifyId-17aabcd0bc1-73501e-172)"
              />
              <ellipse
                fill="url(#IconifyId-17aabcd0bc1-73501e-173)"
                cx="128.327"
                cy="128.242"
                rx="30.327"
                ry="30.302"
              />
            </g>
          </svg>
        </div>
      </OverlayTrigger>
      <OverlayTrigger placement="top" overlay={<Tooltip>Git</Tooltip>}>
        <div className="skill-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            aira-hidden="true"
            focusable="false"
            width="2.38em"
            height="1em"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 256 108"
          >
            <path
              d="M152.984 37.214c-5.597 0-9.765 2.748-9.765 9.362c0 4.983 2.747 8.443 9.463 8.443c5.693 0 9.56-3.355 9.56-8.65c0-6-3.46-9.155-9.258-9.155zm-11.19 46.701c-1.325 1.625-2.645 3.353-2.645 5.39c0 4.067 5.186 5.291 12.31 5.291c5.9 0 13.938-.414 13.938-5.9c0-3.261-3.867-3.462-8.753-3.768l-14.85-1.013zm30.113-46.394c1.828 2.34 3.764 5.597 3.764 10.276c0 11.292-8.851 17.904-21.667 17.904c-3.259 0-6.209-.406-8.038-.914l-3.359 5.39l9.969.61c17.602 1.122 27.975 1.632 27.975 15.157c0 11.702-10.272 18.311-27.975 18.311c-18.413 0-25.433-4.68-25.433-12.716c0-4.578 2.035-7.015 5.596-10.378c-3.358-1.419-4.476-3.961-4.476-6.71c0-2.24 1.118-4.273 2.952-6.208c1.83-1.93 3.864-3.865 6.306-6.103c-4.984-2.442-8.75-7.732-8.75-15.262c0-11.697 7.733-19.731 23.295-19.731c4.376 0 7.022.402 9.362 1.017h19.84v8.644l-9.361.713z"
              fill="#2F2707"
            />
            <path
              d="M199.166 19.034c-5.8 0-9.157-3.36-9.157-9.161c0-5.793 3.356-8.95 9.157-8.95c5.9 0 9.258 3.157 9.258 8.95c0 5.801-3.357 9.161-9.258 9.161zM186.04 80.171v-8.033l5.19-.71c1.425-.205 1.627-.509 1.627-2.038V39.48c0-1.116-.304-1.832-1.325-2.134l-5.492-1.935l1.118-8.238h21.061V69.39c0 1.63.098 1.833 1.629 2.039l5.188.71v8.032H186.04z"
              fill="#2F2707"
            />
            <path
              d="M255.267 76.227c-4.376 2.135-10.785 4.068-16.586 4.068c-12.106 0-16.682-4.878-16.682-16.38V37.264c0-.61 0-1.017-.817-1.017h-7.12V27.19c8.955-1.02 12.513-5.496 13.632-16.585h9.666v14.45c0 .71 0 1.017.815 1.017h14.343v10.173H237.36v24.313c0 6.002 1.426 8.34 6.917 8.34c2.852 0 5.799-.71 8.24-1.626l2.75 8.954"
              fill="#2F2707"
            />
            <path
              d="M104.529 49.53L58.013 3.017a6.86 6.86 0 0 0-9.703 0l-9.659 9.66l12.253 12.252a8.145 8.145 0 0 1 8.383 1.953a8.157 8.157 0 0 1 1.936 8.434L73.03 47.125c2.857-.984 6.154-.347 8.435 1.938a8.161 8.161 0 0 1 0 11.545a8.164 8.164 0 0 1-13.324-8.88L57.129 40.716l-.001 28.98a8.248 8.248 0 0 1 2.159 1.544a8.164 8.164 0 0 1 0 11.547c-3.19 3.19-8.36 3.19-11.545 0a8.164 8.164 0 0 1 2.672-13.328v-29.25a8.064 8.064 0 0 1-2.672-1.782c-2.416-2.413-2.997-5.958-1.759-8.925l-12.078-12.08L2.011 49.314a6.863 6.863 0 0 0 0 9.706l46.516 46.514a6.862 6.862 0 0 0 9.703 0l46.299-46.297a6.866 6.866 0 0 0 0-9.707"
              fill="#DE4C36"
            />
          </svg>
        </div>
      </OverlayTrigger>
      <OverlayTrigger placement="top" overlay={<Tooltip>GitHub</Tooltip>}>
        <div className="skill-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            aira-hidden="true"
            focusable="false"
            width="1.03em"
            height="1em"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 256 250"
          >
            <path
              d="M128.001 0C57.317 0 0 57.307 0 128.001c0 56.554 36.676 104.535 87.535 121.46c6.397 1.185 8.746-2.777 8.746-6.158c0-3.052-.12-13.135-.174-23.83c-35.61 7.742-43.124-15.103-43.124-15.103c-5.823-14.795-14.213-18.73-14.213-18.73c-11.613-7.944.876-7.78.876-7.78c12.853.902 19.621 13.19 19.621 13.19c11.417 19.568 29.945 13.911 37.249 10.64c1.149-8.272 4.466-13.92 8.127-17.116c-28.431-3.236-58.318-14.212-58.318-63.258c0-13.975 5-25.394 13.188-34.358c-1.329-3.224-5.71-16.242 1.24-33.874c0 0 10.749-3.44 35.21 13.121c10.21-2.836 21.16-4.258 32.038-4.307c10.878.049 21.837 1.47 32.066 4.307c24.431-16.56 35.165-13.12 35.165-13.12c6.967 17.63 2.584 30.65 1.255 33.873c8.207 8.964 13.173 20.383 13.173 34.358c0 49.163-29.944 59.988-58.447 63.157c4.591 3.972 8.682 11.762 8.682 23.704c0 17.126-.148 30.91-.148 35.126c0 3.407 2.304 7.398 8.792 6.14C219.37 232.5 256 184.537 256 128.002C256 57.307 198.691 0 128.001 0zm-80.06 182.34c-.282.636-1.283.827-2.194.39c-.929-.417-1.45-1.284-1.15-1.922c.276-.655 1.279-.838 2.205-.399c.93.418 1.46 1.293 1.139 1.931zm6.296 5.618c-.61.566-1.804.303-2.614-.591c-.837-.892-.994-2.086-.375-2.66c.63-.566 1.787-.301 2.626.591c.838.903 1 2.088.363 2.66zm4.32 7.188c-.785.545-2.067.034-2.86-1.104c-.784-1.138-.784-2.503.017-3.05c.795-.547 2.058-.055 2.861 1.075c.782 1.157.782 2.522-.019 3.08zm7.304 8.325c-.701.774-2.196.566-3.29-.49c-1.119-1.032-1.43-2.496-.726-3.27c.71-.776 2.213-.558 3.315.49c1.11 1.03 1.45 2.505.701 3.27zm9.442 2.81c-.31 1.003-1.75 1.459-3.199 1.033c-1.448-.439-2.395-1.613-2.103-2.626c.301-1.01 1.747-1.484 3.207-1.028c1.446.436 2.396 1.602 2.095 2.622zm10.744 1.193c.036 1.055-1.193 1.93-2.715 1.95c-1.53.034-2.769-.82-2.786-1.86c0-1.065 1.202-1.932 2.733-1.958c1.522-.03 2.768.818 2.768 1.868zm10.555-.405c.182 1.03-.875 2.088-2.387 2.37c-1.485.271-2.861-.365-3.05-1.386c-.184-1.056.893-2.114 2.376-2.387c1.514-.263 2.868.356 3.061 1.403z"
              fill="#161614"
            />
          </svg>
        </div>
      </OverlayTrigger>
      <OverlayTrigger placement="top" overlay={<Tooltip>Atlassian</Tooltip>}>
        <div className="skill-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            aira-hidden="true"
            focusable="false"
            width="1em"
            height="1em"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 256 256"
          >
            <defs>
              <linearGradient
                x1="99.687%"
                y1="15.801%"
                x2="39.836%"
                y2="97.438%"
                id="IconifyId-17aabce7780-128612-184"
              >
                <stop stopColor="#0052CC" offset="0%" />
                <stop stopColor="#2684FF" offset="92.3%" />
              </linearGradient>
            </defs>
            <path
              d="M75.793 117.95c-3.82-4.08-9.77-3.85-12.367 1.342L.791 244.565a7.488 7.488 0 0 0 6.697 10.838h87.228a7.22 7.22 0 0 0 6.699-4.14c18.808-38.89 7.413-98.018-25.622-133.314z"
              fill="url(#IconifyId-17aabce7780-128612-184)"
            />
            <path
              d="M121.756 4.011c-35.033 55.505-32.721 116.979-9.646 163.13l42.06 84.121a7.488 7.488 0 0 0 6.697 4.14h87.227a7.488 7.488 0 0 0 6.697-10.838S137.445 9.837 134.493 3.964c-2.64-5.258-9.344-5.33-12.737.047z"
              fill="#2681FF"
            />
          </svg>
        </div>
      </OverlayTrigger>
      <OverlayTrigger placement="top" overlay={<Tooltip>GraphQL</Tooltip>}>
        <div className="skill-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            aira-hidden="true"
            focusable="false"
            width="0.89em"
            height="1em"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 256 288"
          >
            <path
              d="M152.576 32.963l59.146 34.15a25.819 25.819 0 0 1 5.818-4.604c12.266-7.052 27.912-2.865 35.037 9.402c7.052 12.267 2.865 27.912-9.402 35.037a25.698 25.698 0 0 1-6.831 2.72v68.325a25.7 25.7 0 0 1 6.758 2.702c12.34 7.125 16.527 22.771 9.402 35.038c-7.052 12.266-22.771 16.453-35.038 9.402a25.464 25.464 0 0 1-6.34-5.147l-58.786 33.94a25.671 25.671 0 0 1 1.295 8.08c0 14.103-11.458 25.636-25.635 25.636c-14.177 0-25.635-11.46-25.635-25.636c0-2.52.362-4.954 1.037-7.253l-59.13-34.14a25.824 25.824 0 0 1-5.738 4.52c-12.34 7.051-27.986 2.864-35.038-9.402c-7.051-12.267-2.864-27.913 9.402-35.038a25.71 25.71 0 0 1 6.758-2.703v-68.324a25.698 25.698 0 0 1-6.831-2.72C.558 99.897-3.629 84.178 3.423 71.911c7.052-12.267 22.77-16.454 35.037-9.402a25.82 25.82 0 0 1 5.79 4.575l59.163-34.159a25.707 25.707 0 0 1-1.048-7.29C102.365 11.46 113.823 0 128 0c14.177 0 25.635 11.459 25.635 25.635c0 2.548-.37 5.007-1.059 7.328zm-6.162 10.522l59.287 34.23a25.599 25.599 0 0 0 2.437 19.831c3.609 6.278 9.488 10.44 16.013 12.062v68.41c-.333.081-.664.17-.993.264L145.725 44.17c.234-.224.464-.452.689-.684zm-36.123.7l-77.432 134.11a25.824 25.824 0 0 0-1.01-.27v-68.417c6.525-1.622 12.404-5.784 16.013-12.062a25.6 25.6 0 0 0 2.427-19.869l59.27-34.22c.239.247.483.49.732.727zm24.872 6.075l77.414 134.08a25.492 25.492 0 0 0-4.513 5.757a25.7 25.7 0 0 0-2.702 6.758H50.64a25.71 25.71 0 0 0-2.704-6.758a25.825 25.825 0 0 0-4.506-5.724l77.429-134.107A25.715 25.715 0 0 0 128 51.27c2.487 0 4.89-.352 7.163-1.01zm11.795 194.478l58.902-34.008a25.865 25.865 0 0 1-.473-1.682H50.607c-.082.333-.171.663-.266.992l59.19 34.175A25.558 25.558 0 0 1 128 236.373a25.564 25.564 0 0 1 18.958 8.365z"
              fill="#E535AB"
              fillRule="evenodd"
            />
          </svg>
        </div>
      </OverlayTrigger>
      <OverlayTrigger placement="top" overlay={<Tooltip>NPM</Tooltip>}>
        <div className="skill-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            aira-hidden="true"
            focusable="false"
            width="1em"
            height="1em"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 32 32"
          >
            <path
              d="M2 10.555h28v9.335H16v1.556H9.778v-1.557H2zm1.556 7.779h3.111v-4.668h1.555v4.667h1.556v-6.222H3.556zm7.778-6.223v7.779h3.111v-1.556h3.111v-6.223zm3.111 1.556H16v3.112h-1.556zm4.667-1.556v6.223h3.111v-4.668h1.556v4.667h1.556v-4.667h1.556v4.667h1.556v-6.222z"
              fill="#cb3837"
            />
          </svg>
        </div>
      </OverlayTrigger>
      <OverlayTrigger placement="top" overlay={<Tooltip>Yarn</Tooltip>}>
        <div className="skill-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            aira-hidden="true"
            focusable="false"
            width="1em"
            height="1em"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 256 256"
          >
            <path
              d="M128 0C57.328 0 0 57.328 0 128s57.328 128 128 128s128-57.328 128-128S198.672 0 128 0"
              fill="#368FB9"
            />
            <path
              d="M203.317 174.06c-7.907 1.878-11.91 3.608-21.695 9.983c-15.271 9.884-31.976 14.48-31.976 14.48s-1.383 2.076-5.387 3.015c-6.918 1.68-32.963 3.114-35.335 3.163c-6.376.05-10.28-1.63-11.367-4.25c-3.311-7.907 4.744-11.367 4.744-11.367s-1.779-1.087-2.817-2.076c-.939-.939-1.927-2.816-2.224-2.125c-1.235 3.015-1.878 10.379-5.189 13.69c-4.547 4.596-13.146 3.064-18.236.395c-5.585-2.965.395-9.933.395-9.933s-3.015 1.779-5.436-1.878c-2.175-3.36-4.2-9.094-3.657-16.16c.593-8.056 9.587-15.865 9.587-15.865s-1.581-11.91 3.608-24.117c4.695-11.12 17.347-20.065 17.347-20.065s-10.626-11.762-6.672-22.338c2.57-6.92 3.608-6.87 4.448-7.166c2.965-1.137 5.831-2.373 7.957-4.695c10.625-11.466 24.166-9.292 24.166-9.292s6.425-19.52 12.356-15.715c1.828 1.186 8.401 15.814 8.401 15.814s7.018-4.102 7.809-2.57c4.25 8.254 4.744 24.019 2.866 33.607c-3.163 15.814-11.07 24.315-14.233 29.652c-.741 1.236 8.5 5.14 14.332 21.3c5.387 14.777.593 27.182 1.433 28.566c.148.247.198.346.198.346s6.177.494 18.582-7.166c6.622-4.102 14.48-8.698 23.425-8.797c8.65-.149 9.094 9.983 2.57 11.564zm11.763-7.265c-.89-7.017-6.82-11.86-14.431-11.762c-11.367.148-20.905 6.03-27.231 9.934c-2.471 1.532-4.596 2.669-6.425 3.509c.395-5.733.05-13.245-2.916-21.498c-3.608-9.885-8.45-15.963-11.91-19.472c4.003-5.832 9.489-14.332 12.058-27.478c2.224-11.219 1.533-28.664-3.558-38.45c-1.038-1.976-2.767-3.41-4.942-4.003c-.89-.247-2.57-.741-5.881.198c-4.991-10.329-6.721-11.416-8.056-12.306c-2.767-1.779-6.029-2.174-9.093-1.038c-4.102 1.483-7.61 5.437-10.922 12.454a51.47 51.47 0 0 0-1.334 3.015c-6.277.445-16.161 2.718-24.513 11.762c-1.038 1.137-3.064 1.977-5.19 2.768h.05c-4.349 1.532-6.326 5.09-8.747 11.515c-3.361 8.994.098 17.84 3.508 23.574c-4.645 4.151-10.823 10.773-14.084 18.532c-4.053 9.588-4.498 18.978-4.35 24.068c-3.459 3.658-8.796 10.527-9.39 18.237c-.79 10.773 3.114 18.088 4.844 20.756c.494.791 1.038 1.434 1.63 2.076c-.197 1.334-.246 2.768.05 4.25c.643 3.46 2.817 6.277 6.128 8.056c6.524 3.46 15.617 4.942 22.635 1.433c2.52 2.669 7.117 5.239 15.469 5.239h.494c2.125 0 29.109-1.433 36.967-3.36c3.509-.841 5.93-2.324 7.512-3.658c5.04-1.582 18.977-6.326 32.123-14.826c9.291-6.03 12.504-7.315 19.423-8.995c6.72-1.63 10.922-7.759 10.082-14.53z"
              fill="#FFF"
            />
          </svg>
        </div>
      </OverlayTrigger>
      <OverlayTrigger placement="top" overlay={<Tooltip>Prettier</Tooltip>}>
        <div className="skill-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            aira-hidden="true"
            focusable="false"
            width="1em"
            height="1em"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 256 256"
          >
            <rect
              fill="#56B3B4"
              x="182.857"
              y="48.762"
              width="24.381"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#EA5E5E"
              y="243.81"
              width="73.143"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#BF85BF"
              x="146.286"
              y="146.286"
              width="48.762"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#EA5E5E"
              x="73.143"
              y="146.286"
              width="60.952"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#56B3B4"
              y="146.286"
              width="60.952"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#BF85BF"
              y="195.048"
              width="73.143"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#BF85BF"
              y="97.524"
              width="73.143"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#F7BA3E"
              x="60.952"
              y="24.381"
              width="134.095"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#EA5E5E"
              y="24.381"
              width="48.762"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#F7BA3E"
              x="48.762"
              y="219.429"
              width="24.381"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#56B3B4"
              x="48.762"
              y="73.143"
              width="24.381"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#56B3B4"
              y="219.429"
              width="36.571"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#F7BA3E"
              y="73.143"
              width="36.571"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#D0D4D8"
              opacity=".5"
              x="158.476"
              y="219.429"
              width="24.381"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#D0D4D8"
              opacity=".5"
              x="85.333"
              y="219.429"
              width="60.952"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#D0D4D8"
              opacity=".5"
              x="195.048"
              y="219.429"
              width="60.952"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#56B3B4"
              x="97.524"
              y="121.905"
              width="109.714"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#F7BA3E"
              x="36.571"
              y="121.905"
              width="48.762"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#EA5E5E"
              y="121.905"
              width="24.381"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#BF85BF"
              x="109.714"
              y="48.762"
              width="60.952"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#56B3B4"
              y="48.762"
              width="97.524"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#F7BA3E"
              x="36.571"
              y="170.667"
              width="121.905"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#BF85BF"
              y="170.667"
              width="24.381"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#EA5E5E"
              x="146.286"
              y="73.143"
              width="73.143"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#F7BA3E"
              x="146.286"
              y="97.524"
              width="73.143"
              height="12.19"
              rx="5"
            />
            <rect fill="#56B3B4" width="158.476" height="12.19" rx="5" />
            <rect
              fill="#D0D4D8"
              opacity=".5"
              x="170.667"
              width="85.333"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#D0D4D8"
              opacity=".5"
              x="170.667"
              y="170.667"
              width="36.571"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#D0D4D8"
              opacity=".5"
              x="219.429"
              y="170.667"
              width="36.571"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#D0D4D8"
              opacity=".5"
              x="207.238"
              y="146.286"
              width="48.762"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#D0D4D8"
              opacity=".5"
              x="207.238"
              y="24.381"
              width="48.762"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#D0D4D8"
              opacity=".5"
              x="219.429"
              y="121.905"
              width="36.571"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#D0D4D8"
              opacity=".5"
              x="219.429"
              y="48.762"
              width="36.571"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#D0D4D8"
              opacity=".5"
              x="231.619"
              y="73.143"
              width="24.381"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#D0D4D8"
              opacity=".5"
              x="231.619"
              y="97.524"
              width="24.381"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#D0D4D8"
              opacity=".5"
              x="134.095"
              y="195.048"
              width="121.905"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#D0D4D8"
              opacity=".5"
              x="85.333"
              y="195.048"
              width="36.571"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#D0D4D8"
              opacity=".5"
              x="182.857"
              y="243.81"
              width="73.143"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#D0D4D8"
              opacity=".5"
              x="85.333"
              y="243.81"
              width="85.333"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#D0D4D8"
              opacity=".5"
              x="85.333"
              y="73.143"
              width="48.762"
              height="12.19"
              rx="5"
            />
            <rect
              fill="#D0D4D8"
              opacity=".5"
              x="85.333"
              y="97.524"
              width="48.762"
              height="12.19"
              rx="5"
            />
          </svg>
        </div>
      </OverlayTrigger>
      <OverlayTrigger placement="top" overlay={<Tooltip>MySQL</Tooltip>}>
        <div className="skill-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            aira-hidden="true"
            focusable="false"
            width="1em"
            height="1em"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 32 32"
          >
            <path
              d="M8.785 6.865a3.055 3.055 0 0 0-.785.1V7h.038a6.461 6.461 0 0 0 .612.785c.154.306.288.611.441.917l.038-.039a1.074 1.074 0 0 0 .4-.957a4.314 4.314 0 0 1-.23-.4c-.115-.191-.364-.287-.517-.44"
              fill="#5d87a1"
              fillRule="evenodd"
            />
            <path
              d="M27.78 23.553a8.849 8.849 0 0 0-3.712.536c-.287.115-.745.115-.785.478c.154.153.172.4.307.613a4.467 4.467 0 0 0 .995 1.167c.4.306.8.611 1.225.879c.745.461 1.588.728 2.314 1.187c.422.268.842.612 1.264.9c.21.153.343.4.611.5v-.058a3.844 3.844 0 0 0-.291-.613c-.191-.19-.383-.363-.575-.554a9.118 9.118 0 0 0-1.99-1.932c-.613-.422-1.953-1-2.2-1.7l-.039-.039a7.69 7.69 0 0 0 1.321-.308c.65-.172 1.243-.133 1.912-.3c.307-.077.862-.268.862-.268v-.3c-.342-.34-.587-.795-.947-1.116a25.338 25.338 0 0 0-3.122-2.328c-.587-.379-1.344-.623-1.969-.946c-.226-.114-.6-.17-.737-.36a7.594 7.594 0 0 1-.776-1.457a46.84 46.84 0 0 1-1.551-3.293a20.236 20.236 0 0 0-.965-2.157A19.078 19.078 0 0 0 11.609 5a9.07 9.07 0 0 0-2.421-.776c-.474-.02-.946-.057-1.419-.075a7.55 7.55 0 0 1-.869-.664C5.818 2.8 3.038 1.328 2.242 3.277C1.732 4.508 3 5.718 3.435 6.343A8.866 8.866 0 0 1 4.4 7.762c.133.322.171.663.3 1a22.556 22.556 0 0 0 .987 2.538a8.946 8.946 0 0 0 .7 1.172c.153.209.417.3.474.645a5.421 5.421 0 0 0-.436 1.419a8.336 8.336 0 0 0 .549 6.358c.3.473 1.022 1.514 1.987 1.116c.851-.34.662-1.419.908-2.364c.056-.229.019-.379.132-.53v.184s.483 1.061.723 1.6a10.813 10.813 0 0 0 2.4 2.59A3.514 3.514 0 0 1 14 24.657V25h.427a1.054 1.054 0 0 0-.427-.788a9.4 9.4 0 0 1-.959-1.16a24.992 24.992 0 0 1-2.064-3.519c-.3-.6-.553-1.258-.793-1.857c-.11-.231-.11-.58-.295-.7a7.266 7.266 0 0 0-.884 1.313a11.419 11.419 0 0 0-.517 2.921c-.073.02-.037 0-.073.038c-.589-.155-.792-.792-1.014-1.332a8.756 8.756 0 0 1-.166-5.164c.128-.405.683-1.681.461-2.068c-.111-.369-.48-.58-.682-.871a7.767 7.767 0 0 1-.663-1.237C5.912 9.5 5.69 8.3 5.212 7.216a10.4 10.4 0 0 0-.921-1.489A9.586 9.586 0 0 1 3.276 4.22c-.092-.213-.221-.561-.074-.793a.3.3 0 0 1 .259-.252c.238-.212.921.058 1.16.174a9.2 9.2 0 0 1 1.824.967c.258.194.866.685.866.685h.18c.612.133 1.3.037 1.876.21a12.247 12.247 0 0 1 2.755 1.32a16.981 16.981 0 0 1 5.969 6.545c.23.439.327.842.537 1.3c.4.94.9 1.9 1.3 2.814a12.578 12.578 0 0 0 1.36 2.564c.286.4 1.435.612 1.952.822a13.7 13.7 0 0 1 1.32.535c.651.4 1.3.861 1.913 1.3c.305.23 1.262.708 1.32 1.091"
              fill="#00758f"
              fillRule="evenodd"
            />
          </svg>
        </div>
      </OverlayTrigger>
      <OverlayTrigger placement="top" overlay={<Tooltip>MongoDB</Tooltip>}>
        <div className="skill-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            aria-hidden="true"
            focusable="false"
            width="1em"
            height="1em"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 32 32"
          >
            <defs>
              <linearGradient
                id="IconifyId-17aafbf0c20-9a13c2-48"
                x1="-645.732"
                y1="839.188"
                x2="-654.59"
                y2="839.25"
                gradientTransform="matrix(-.977 -.323 -.29 .877 -375.944 -928.287)"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset=".231" stopColor="#999875" />
                <stop offset=".563" stopColor="#9b9977" />
                <stop offset=".683" stopColor="#a09f7e" />
                <stop offset=".768" stopColor="#a9a889" />
                <stop offset=".837" stopColor="#b7b69a" />
                <stop offset=".896" stopColor="#c9c7b0" />
                <stop offset=".948" stopColor="#deddcb" />
                <stop offset=".994" stopColor="#f8f6eb" />
                <stop offset="1" stopColor="#fbf9ef" />
              </linearGradient>
              <linearGradient
                id="IconifyId-17aafbf0c20-9a13c2-49"
                x1="-644.287"
                y1="823.405"
                x2="-657.028"
                y2="845.476"
                gradientTransform="matrix(-.977 -.323 -.29 .877 -375.944 -928.287)"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0" stopColor="#48a547" />
                <stop offset="1" stopColor="#3f9143" />
              </linearGradient>
              <linearGradient
                id="IconifyId-17aafbf0c20-9a13c2-50"
                x1="-643.386"
                y1="839.485"
                x2="-652.418"
                y2="833.417"
                gradientTransform="matrix(-.977 -.323 -.29 .877 -375.944 -928.287)"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0" stopColor="#41a247" />
                <stop offset=".352" stopColor="#4ba74b" />
                <stop offset=".956" stopColor="#67b554" />
                <stop offset="1" stopColor="#69b655" />
              </linearGradient>
            </defs>
            <path
              d="M16.62 30l-.751-.249s.1-3.8-1.275-4.067c-.9-1.048.133-44.741 3.423-.149a2.712 2.712 0 0 0-1.333 1.523A14.1 14.1 0 0 0 16.62 30z"
              fill="url(#IconifyId-17aafbf0c20-9a13c2-48)"
            />
            <path
              d="M17.026 26.329a13.223 13.223 0 0 0 5-13.225c-1.47-6.485-4.951-8.617-5.326-9.431a9.792 9.792 0 0 1-.825-1.6l.277 18.069s-.574 5.522.874 6.187z"
              fill="url(#IconifyId-17aafbf0c20-9a13c2-49)"
            />
            <path
              d="M15.487 26.569S9.366 22.4 9.72 15.025a15.54 15.54 0 0 1 5.519-11.648A1.725 1.725 0 0 0 15.846 2c.381.82.319 12.243.359 13.579c.155 5.197-.289 10.009-.718 10.99z"
              fill="url(#IconifyId-17aafbf0c20-9a13c2-50)"
            />
          </svg>
        </div>
      </OverlayTrigger>
      <OverlayTrigger placement="top" overlay={<Tooltip>PostgreSQL</Tooltip>}>
        <div className="skill-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            aira-hidden="true"
            focusable="false"
            width="0.97em"
            height="1em"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 256 264"
          >
            <path
              d="M255.008 158.086c-1.535-4.649-5.556-7.887-10.756-8.664c-2.452-.366-5.26-.21-8.583.475c-5.792 1.195-10.089 1.65-13.225 1.738c11.837-19.985 21.462-42.775 27.003-64.228c8.96-34.689 4.172-50.492-1.423-57.64C233.217 10.847 211.614.683 185.552.372c-13.903-.17-26.108 2.575-32.475 4.549c-5.928-1.046-12.302-1.63-18.99-1.738c-12.537-.2-23.614 2.533-33.079 8.15c-5.24-1.772-13.65-4.27-23.362-5.864c-22.842-3.75-41.252-.828-54.718 8.685C6.622 25.672-.937 45.684.461 73.634c.444 8.874 5.408 35.874 13.224 61.48c4.492 14.718 9.282 26.94 14.237 36.33c7.027 13.315 14.546 21.156 22.987 23.972c4.731 1.576 13.327 2.68 22.368-4.85c1.146 1.388 2.675 2.767 4.704 4.048c2.577 1.625 5.728 2.953 8.875 3.74c11.341 2.835 21.964 2.126 31.027-1.848c.056 1.612.099 3.152.135 4.482c.06 2.157.12 4.272.199 6.25c.537 13.374 1.447 23.773 4.143 31.049c.148.4.347 1.01.557 1.657c1.345 4.118 3.594 11.012 9.316 16.411c5.925 5.593 13.092 7.308 19.656 7.308c3.292 0 6.433-.432 9.188-1.022c9.82-2.105 20.973-5.311 29.041-16.799c7.628-10.86 11.336-27.217 12.007-52.99c.087-.729.167-1.425.244-2.088l.16-1.362l1.797.158l.463.031c10.002.456 22.232-1.665 29.743-5.154c5.935-2.754 24.954-12.795 20.476-26.351"
              fill="#000"
            />
            <path
              d="M237.906 160.722c-29.74 6.135-31.785-3.934-31.785-3.934c31.4-46.593 44.527-105.736 33.2-120.211c-30.904-39.485-84.399-20.811-85.292-20.327l-.287.052c-5.876-1.22-12.451-1.946-19.842-2.067c-13.456-.22-23.664 3.528-31.41 9.402c0 0-95.43-39.314-90.991 49.444c.944 18.882 27.064 142.873 58.218 105.422c11.387-13.695 22.39-25.274 22.39-25.274c5.464 3.63 12.006 5.482 18.864 4.817l.533-.452c-.166 1.7-.09 3.363.213 5.332c-8.026 8.967-5.667 10.541-21.711 13.844c-16.235 3.346-6.698 9.302-.471 10.86c7.549 1.887 25.013 4.561 36.813-11.958l-.47 1.885c3.144 2.519 5.352 16.383 4.982 28.952c-.37 12.568-.617 21.197 1.86 27.937c2.479 6.74 4.948 21.905 26.04 17.386c17.623-3.777 26.756-13.564 28.027-29.89c.901-11.606 2.942-9.89 3.07-20.267l1.637-4.912c1.887-15.733.3-20.809 11.157-18.448l2.64.232c7.99.363 18.45-1.286 24.589-4.139c13.218-6.134 21.058-16.377 8.024-13.686h.002"
              fill="#336791"
            />
            <path
              d="M108.076 81.525c-2.68-.373-5.107-.028-6.335.902c-.69.523-.904 1.129-.962 1.546c-.154 1.105.62 2.327 1.096 2.957c1.346 1.784 3.312 3.01 5.258 3.28c.282.04.563.058.842.058c3.245 0 6.196-2.527 6.456-4.392c.325-2.336-3.066-3.893-6.355-4.35"
              fill="#FFF"
            />
            <path
              d="M196.86 81.599c-.256-1.831-3.514-2.353-6.606-1.923c-3.088.43-6.082 1.824-5.832 3.659c.2 1.427 2.777 3.863 5.827 3.863c.258 0 .518-.017.78-.054c2.036-.282 3.53-1.575 4.24-2.32c1.08-1.136 1.706-2.402 1.591-3.225"
              fill="#FFF"
            />
            <path
              d="M247.802 160.025c-1.134-3.429-4.784-4.532-10.848-3.28c-18.005 3.716-24.453 1.142-26.57-.417c13.995-21.32 25.508-47.092 31.719-71.137c2.942-11.39 4.567-21.968 4.7-30.59c.147-9.463-1.465-16.417-4.789-20.665c-13.402-17.125-33.072-26.311-56.882-26.563c-16.369-.184-30.199 4.005-32.88 5.183c-5.646-1.404-11.801-2.266-18.502-2.376c-12.288-.199-22.91 2.743-31.704 8.74c-3.82-1.422-13.692-4.811-25.765-6.756c-20.872-3.36-37.458-.814-49.294 7.571c-14.123 10.006-20.643 27.892-19.38 53.16c.425 8.501 5.269 34.653 12.913 59.698c10.062 32.964 21 51.625 32.508 55.464c1.347.449 2.9.763 4.613.763c4.198 0 9.345-1.892 14.7-8.33a529.832 529.832 0 0 1 20.261-22.926c4.524 2.428 9.494 3.784 14.577 3.92c.01.133.023.266.035.398a117.66 117.66 0 0 0-2.57 3.175c-3.522 4.471-4.255 5.402-15.592 7.736c-3.225.666-11.79 2.431-11.916 8.435c-.136 6.56 10.125 9.315 11.294 9.607c4.074 1.02 7.999 1.523 11.742 1.523c9.103 0 17.114-2.992 23.516-8.781c-.197 23.386.778 46.43 3.586 53.451c2.3 5.748 7.918 19.795 25.664 19.794c2.604 0 5.47-.303 8.623-.979c18.521-3.97 26.564-12.156 29.675-30.203c1.665-9.645 4.522-32.676 5.866-45.03c2.836.885 6.487 1.29 10.434 1.289c8.232 0 17.731-1.749 23.688-4.514c6.692-3.108 18.768-10.734 16.578-17.36zm-44.106-83.48c-.061 3.647-.563 6.958-1.095 10.414c-.573 3.717-1.165 7.56-1.314 12.225c-.147 4.54.42 9.26.968 13.825c1.108 9.22 2.245 18.712-2.156 28.078a36.508 36.508 0 0 1-1.95-4.009c-.547-1.326-1.735-3.456-3.38-6.404c-6.399-11.476-21.384-38.35-13.713-49.316c2.285-3.264 8.084-6.62 22.64-4.813zm-17.644-61.787c21.334.471 38.21 8.452 50.158 23.72c9.164 11.711-.927 64.998-30.14 110.969a171.33 171.33 0 0 0-.886-1.117l-.37-.462c7.549-12.467 6.073-24.802 4.759-35.738c-.54-4.488-1.05-8.727-.92-12.709c.134-4.22.692-7.84 1.232-11.34c.663-4.313 1.338-8.776 1.152-14.037c.139-.552.195-1.204.122-1.978c-.475-5.045-6.235-20.144-17.975-33.81c-6.422-7.475-15.787-15.84-28.574-21.482c5.5-1.14 13.021-2.203 21.442-2.016zM66.674 175.778c-5.9 7.094-9.974 5.734-11.314 5.288c-8.73-2.912-18.86-21.364-27.791-50.624c-7.728-25.318-12.244-50.777-12.602-57.916c-1.128-22.578 4.345-38.313 16.268-46.769c19.404-13.76 51.306-5.524 64.125-1.347c-.184.182-.376.352-.558.537c-21.036 21.244-20.537 57.54-20.485 59.759c-.002.856.07 2.068.168 3.735c.362 6.105 1.036 17.467-.764 30.334c-1.672 11.957 2.014 23.66 10.111 32.109a36.275 36.275 0 0 0 2.617 2.468c-3.604 3.86-11.437 12.396-19.775 22.426zm22.479-29.993c-6.526-6.81-9.49-16.282-8.133-25.99c1.9-13.592 1.199-25.43.822-31.79c-.053-.89-.1-1.67-.127-2.285c3.073-2.725 17.314-10.355 27.47-8.028c4.634 1.061 7.458 4.217 8.632 9.645c6.076 28.103.804 39.816-3.432 49.229c-.873 1.939-1.698 3.772-2.402 5.668l-.546 1.466c-1.382 3.706-2.668 7.152-3.465 10.424c-6.938-.02-13.687-2.984-18.819-8.34zm1.065 37.9c-2.026-.506-3.848-1.385-4.917-2.114c.893-.42 2.482-.992 5.238-1.56c13.337-2.745 15.397-4.683 19.895-10.394c1.031-1.31 2.2-2.794 3.819-4.602l.002-.002c2.411-2.7 3.514-2.242 5.514-1.412c1.621.67 3.2 2.702 3.84 4.938c.303 1.056.643 3.06-.47 4.62c-9.396 13.156-23.088 12.987-32.921 10.526zm69.799 64.952c-16.316 3.496-22.093-4.829-25.9-14.346c-2.457-6.144-3.665-33.85-2.808-64.447c.011-.407-.047-.8-.159-1.17a15.444 15.444 0 0 0-.456-2.162c-1.274-4.452-4.379-8.176-8.104-9.72c-1.48-.613-4.196-1.738-7.46-.903c.696-2.868 1.903-6.107 3.212-9.614l.549-1.475c.618-1.663 1.394-3.386 2.214-5.21c4.433-9.848 10.504-23.337 3.915-53.81c-2.468-11.414-10.71-16.988-23.204-15.693c-7.49.775-14.343 3.797-17.761 5.53c-.735.372-1.407.732-2.035 1.082c.954-11.5 4.558-32.992 18.04-46.59c8.489-8.56 19.794-12.788 33.568-12.56c27.14.444 44.544 14.372 54.366 25.979c8.464 10.001 13.047 20.076 14.876 25.51c-13.755-1.399-23.11 1.316-27.852 8.096c-10.317 14.748 5.644 43.372 13.315 57.129c1.407 2.521 2.621 4.7 3.003 5.626c2.498 6.054 5.732 10.096 8.093 13.046c.724.904 1.426 1.781 1.96 2.547c-4.166 1.201-11.649 3.976-10.967 17.847c-.55 6.96-4.461 39.546-6.448 51.059c-2.623 15.21-8.22 20.875-23.957 24.25zm68.104-77.936c-4.26 1.977-11.389 3.46-18.161 3.779c-7.48.35-11.288-.838-12.184-1.569c-.42-8.644 2.797-9.547 6.202-10.503c.535-.15 1.057-.297 1.561-.473c.313.255.656.508 1.032.756c6.012 3.968 16.735 4.396 31.874 1.271l.166-.033c-2.042 1.909-5.536 4.471-10.49 6.772z"
              fill="#FFF"
            />
          </svg>
        </div>
      </OverlayTrigger>
    </div>
  )
}

export default SkillShowcase
